'use client';

import { useResponsiveQuery } from 'atomic-layout';
import Image from 'next/image';
import React from 'react';

import { BannerProps as BannerCMSProps } from '@/types/cms';

import * as S from './styles';

interface BannerProps
  extends Omit<
    BannerCMSProps,
    'id' | 'referId' | 'titleDescriptionTag' | 'iconsDescriptions' | 'buttons'
  > {
  id: string;
  title: string;
  description: string;
}

const Banner: React.FC<BannerProps> = ({
  id,
  title,
  description,
  machineImage,
  bannerImages,
}) => {
  const isMobile = useResponsiveQuery({ to: 'md' });

  return (
    <S.Container id={id}>
      <S.ImageContainer>
        <Image
          src={isMobile ? bannerImages.mobile.path : bannerImages.web.path}
          alt={
            isMobile
              ? bannerImages.mobile.alternativeText
              : bannerImages.web.alternativeText
          }
          key={`img-${isMobile ? 'mobile' : 'desktop'}`}
          width={768}
          height={560}
          priority
          quality={80}
          className="object-cover w-full"
        />
      </S.ImageContainer>
      {machineImage && isMobile && (
        <S.MobileImageContainer>
          <Image
            src={machineImage.path}
            alt={machineImage.alternativeText}
            width={250}
            height={320}
            priority
            quality={80}
            className="z-10"
          />
        </S.MobileImageContainer>
      )}
      <S.RightSideContainer>
        <h1 className="heading-1">{title}</h1>
        <p>{description}</p>
      </S.RightSideContainer>
    </S.Container>
  );
};

export default Banner;
